import React from "react";
import { STEP_GROUP_IDS } from "../../../../shared/config";
import { KYC_MANUAL_NAMES } from "../../KycManual/config";
import AdditionalDataBirthInfoNieEu from "./steps/AdditionalDataBirthInfoNieEu";
import AdditionalDataDocIdPictureNieEu from "./steps/AdditionalDataDocIdPictureNieEu";

export default function NieEuAdditionalData({
  participant,
  currentModuleStepHandler,
}) {
  const FORM_NAMES = {
    BIRTH_INFO_NIE_EU: "BIRTH_INFO_NIE_EU",
    DOC_ID_PICTURE_NIE_EU: "DOC_ID_PICTURE_NIE_EU",
  };

  const { submitStep, manageGroup, getStepData } = currentModuleStepHandler;

  const showBirthInfoNieEu = (allStepValues) => {
    return (
      !participant.onboardingDetails?.user_details?.document_id.gender &&
      !participant.onboardingDetails?.user_details?.document_id.nationality &&
      allStepValues[KYC_MANUAL_NAMES.BIRTH_INFO_FORM] === undefined
    );
  };

  const STEP_GROUP_STEPS_ARRAY = [
    {
      id: FORM_NAMES.BIRTH_INFO_NIE_EU,
      show: showBirthInfoNieEu,
    },
    {
      id: FORM_NAMES.DOC_ID_PICTURE_NIE_EU,
      show: () => true,
    },
  ];

  const CURRENT_STEP_GROUP = STEP_GROUP_IDS.NieEuAdditionalData;

  const stepGroupStepToShow = manageGroup(
    CURRENT_STEP_GROUP,
    STEP_GROUP_STEPS_ARRAY
  );

  return (
    <>
      {stepGroupStepToShow === FORM_NAMES.BIRTH_INFO_NIE_EU && (
        <AdditionalDataBirthInfoNieEu
          onSubmitForm={submitStep}
          data={getStepData()}
        />
      )}
      {stepGroupStepToShow === FORM_NAMES.DOC_ID_PICTURE_NIE_EU && (
        <AdditionalDataDocIdPictureNieEu
          onSubmitForm={submitStep}
          data={getStepData()}
        />
      )}
    </>
  );
}
